var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('a',{attrs:{"href":_vm.invoicePdfLink(this.invoiceId),"target":"_blank"},on:{"click":_vm.getCurrentCookies}},[_vm._v(_vm._s(_vm.linkDescription)+" ")])])}
var staticRenderFns = []

export { render, staticRenderFns }